import { AddResidentBioForm } from "app/services/api/types/residents/models/AddResidentBioForm";
import { ResidentInputFields } from "app/services/api/types/residents/models/ResidentInputFields";
import { Control } from "react-hook-form";
import { View, Text } from "react-native";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";

interface Props {
  fields: ResidentInputFields[];
  remove: (index: number) => void;
  control: Control<AddResidentBioForm>;
  index: number;
}

export function NextOfKinGroup({ fields, control, remove, index }: Props) {
  return (
    <View key={index} className="mt-4">
      <View className="flex flex-row pt-7 pb-5 justify-between md:w-11/12">
        <Text className="text-regular font-normal text-typography-600">
          Next of Kin {String.fromCharCode(65 + index)}
        </Text>
        {index > 0 ? (
          <Text
            onPress={() => remove(index)}
            className="text-primary-500 font-medium text-xs"
          >
            Remove
          </Text>
        ) : null}
      </View>
      <View className="md:w-11/12 grid md:grid-cols-3 gap-8">
        {fields.map(({ id, name, label, placeholder, isRequired, rules }) => (
          <View key={id + index}>
            <FormControlledInput
              id={`${id}${index}`}
              name={`relatives.${index}.${name}`}
              control={control}
              label={label}
              placeholder={placeholder}
              isRequired={isRequired}
              rules={rules}
            />
          </View>
        ))}
      </View>
    </View>
  );
}
